import { useEffect, useState } from "react";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";

interface InfoInventoryProps {
    task: ITaskAnimalUpdateInventory | undefined;
}

export default function InfoInventory(task: InfoInventoryProps) {
    const [taskGrazingRoute, setTaskGrazingRoute] = useState<ITaskAnimalUpdateInventory>();

    useEffect(() => {
        setTaskGrazingRoute(task.task)
    }, []);

    return (
        <>
            <div >
                <span>Lote</span>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <AnimalsIcon width={30} className="iconInitialTaskInfo" />
                    <div className="labelInitialTaskInfo">
                        <span>LT001</span>
                        <PointIcon width={15} />
                    </div>
                </div>
            </div>

            <div className="containerQuestion">
                {taskGrazingRoute?.categories.map((item, index) => (
                    <div style={{ display: "flex", gap: 10 }}>
                        <MessageBalloon text={`${item.quantity}`} />
                        <MessageBalloon text={`${item.category_description.name} ${item.category_description.age_description}`} />
                    </div>
                ))
                }
            </div>
        </>
    )
}